import { ActivityDashboardResponse } from "../../api/analyticsAdmin";
import { MonthlyPoint, completeMonthRange } from "../../helpers/dashboardMetrics";
import { MonthlyActivity } from "./useDashboardData";

// App-side figures come from a period endpoint, not a monthly series: one call
// returns totals for whatever range it is given. The two the page fetches — the
// month that has just ended and the one before — are what make them comparable
// month over month, on the same footing as every other figure on the page.
//
// Two points is all they have, which is enough for a delta. StatTile draws no
// sparkline below three, so they render as a figure and its change.
export const activitySeries = (
  activity: MonthlyActivity | null,
  today: Date,
  pick: (data: ActivityDashboardResponse) => number | null | undefined
): MonthlyPoint[] => {
  if (!activity) return [];
  const previous = pick(activity.previous);
  const latest = pick(activity.latest);
  if (typeof previous !== "number" || typeof latest !== "number") return [];
  return [
    { month: completeMonthRange(today, 2).month, value: previous },
    { month: completeMonthRange(today, 1).month, value: latest },
  ];
};
